export default __webpack_public_path__ + "static/media/menu_button_active.43610ba6.svg";